import { SecureLinkEntityType } from '@aiwyn/auth';
import { InputSignal, TemplateRef } from '@angular/core';
import {
  GrantEntity,
  SecureLinkEngagement,
  SecureLinkEntityIdentity,
  SecureLinkEntityStatus,
  SecureLinkEntityTypeToEntityMap,
} from './secure-link.models';
import { BaseJob } from '@aiwyn/api';
import { TemplateOutletContext } from '@aiwyn/shared';

export type SecureLinkNavSectionEntity = BaseJob | SecureLinkEngagement;

export interface SecureLinkNavSection<SectionEntity extends SecureLinkNavSectionEntity = SecureLinkNavSectionEntity> {
  headerDisplay: {
    ref: TemplateRef<TemplateOutletContext<SectionEntity>>;
    context: TemplateOutletContext<SectionEntity>;
  };
  navItems: GrantEntity[];
}

export type OnSecureLinkEntityStatusUpdatedFn = (entityId: SecureLinkEntityIdentity, status: SecureLinkEntityStatus) => void;

export abstract class SecureLinkDisplayAdaptor<EntityType extends SecureLinkEntityType = SecureLinkEntityType> {
  entity: InputSignal<SecureLinkEntityTypeToEntityMap<EntityType>>;
  onStatusUpdated: InputSignal<OnSecureLinkEntityStatusUpdatedFn>;
  canShowCompletionDialog: InputSignal<boolean>;

  static normalizeStatus(_: string): SecureLinkEntityStatus {
    throw new Error('Method not implemented.');
  }

  static getEntityIdentity(entity: SecureLinkEntityTypeToEntityMap<SecureLinkEntityType>): SecureLinkEntityIdentity {
    throw new Error('Method not implemented.');
  }
}
